import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["action", "gap", "numberOfOperations"];
import { LayoutSpaceVertical } from 'breeze-intelligence-kit';
import { When } from 'policy-lib';
import { UsageDisclaimer } from '../Usage/UsageDisclaimer';
import { UsageEstimate } from '../Usage/UsageEstimate';
import { UsageSection } from '../Usage/UsageSection';
import { useCreditCheck } from 'policy-lib';
import { useEnrichmentCredits } from '../EnrichmentCreditsProvider';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const PanelUsage = _ref => {
  let {
      action,
      gap = 'space-sm',
      numberOfOperations
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    creditsPolicy
  } = useEnrichmentCredits();
  const {
    isAuthorized
  } = useCreditCheck({
    action,
    numberOfOperations
  });
  const shouldSeeDisclaimer = isAuthorized;
  return /*#__PURE__*/_jsxs(LayoutSpaceVertical, Object.assign({
    gap: gap
  }, rest, {
    children: [/*#__PURE__*/_jsx(UsageEstimate, {
      action: action,
      numberOfOperations: numberOfOperations
    }), /*#__PURE__*/_jsx(UsageSection, {
      action: action,
      maxInlineSize: "30rem"
    }), /*#__PURE__*/_jsx(When, {
      can: "hubspotCredits",
      policy: creditsPolicy,
      children: /*#__PURE__*/_jsx(UsageDisclaimer, {
        action: action,
        isVisible: shouldSeeDisclaimer
      })
    })]
  }));
};